import React from 'react';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';

import getSort, { sortByName } from 'utils/sorts';

import Debt from 'components/DebtEditable';
import DebtNew from './DebtNew';

const DebtGrid = styled.div`
  display: grid;
  flex: 1 1 auto;
  width: 100%;
  overflow: auto;
  padding: 10px;
  grid-area: Content;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const DebtEditor = ({ debts, disabled, settings, onAdd, onRemove, onChange }) => {
  const { sortDirection, sortMethod } = getSort(settings.sort);

  const currentDebts = orderBy(debts.filter(d => !d.isNew), [sortMethod, sortByName], [sortDirection, 'asc']);
  const newDebts = debts.filter(d => d.isNew);
  const debtList = [...currentDebts, ...newDebts];

  return (
    <DebtGrid>
      {debtList.map((debt, i) => <Debt key={debt.id} details={debt} />)}
      <DebtNew onClick={() => onAdd()} />
    </DebtGrid>
  );
};

export default DebtEditor;



// WEBPACK FOOTER //
// ./src/components/DebtEditor/DebtEditor.js